import { FormBuilder, Validators } from '@angular/forms';

export const buildReferralSourceChannelForm = (fb: FormBuilder) =>
  fb.group({
    label: ['', Validators.required],
    code: ['', Validators.required],
    requires_additional_info: [false],
    display_order: [0],
    is_active: [true],
  });
